import { useEffect } from 'react';

export default function SEO() {
  useEffect(() => {
    const prevTitle = document.title;
    document.title = '关于我们 - 蜜桃视频 | 品牌介绍与联系方式';

    const metaDescription = document.querySelector('meta[name="description"]');
    const prevDesc = metaDescription?.getAttribute('content') || '';
    if (metaDescription) {
      metaDescription.setAttribute('content', '了解蜜桃视频的品牌故事、发展历程、创作者口碑与联系方式。蜜桃视频是专注优质短视频内容的创作与分享平台，汇聚海量精彩视频资源。');
    }

    const metaKeywords = document.querySelector('meta[name="keywords"]');
    const prevKeywords = metaKeywords?.getAttribute('content') || '';
    if (metaKeywords) {
      metaKeywords.setAttribute('content', '蜜桃视频,蜜桃视频关于我们,蜜桃视频品牌介绍,蜜桃视频联系方式,蜜桃视频创作者生态');
    }

    const canonical = document.querySelector('link[rel="canonical"]');
    const prevHref = canonical?.getAttribute('href') || '';
    if (canonical) {
      canonical.setAttribute('href', 'https://www.mitaovideo.com/about');
    }

    let scriptEl: HTMLScriptElement | null = null;
    const existingScript = document.querySelector('script[data-schema="about-page"]');
    if (!existingScript) {
      const jsonLd = {
        '@context': 'https://schema.org',
        '@graph': [
          {
            '@type': 'Organization',
            name: '蜜桃视频',
            url: 'https://www.mitaovideo.com',
            description: '蜜桃视频是专注优质短视频内容的创作与分享平台，汇聚海量精彩视频资源。',
            email: 'support@mitaovideo.com',
            telephone: '400-888-9999',
            address: {
              '@type': 'PostalAddress',
              addressLocality: '北京',
              addressRegion: '海淀区',
              streetAddress: '中关村科技园区创新路88号蜜桃大厦',
              addressCountry: 'CN',
            },
            sameAs: [
              'https://weibo.com/mitaovideo',
              'https://space.bilibili.com/mitaovideo',
            ],
          },
          {
            '@type': 'WebSite',
            name: '蜜桃视频',
            url: 'https://www.mitaovideo.com',
            description: '精选短视频内容平台，发现精彩，记录生活。',
            potentialAction: {
              '@type': 'SearchAction',
              target: 'https://www.mitaovideo.com/search?q={search_term_string}',
              'query-input': 'required name=search_term_string',
            },
          },
          {
            '@type': 'WebPage',
            name: '关于我们 - 蜜桃视频',
            url: 'https://www.mitaovideo.com/about',
            description: '了解蜜桃视频的品牌故事、发展历程、创作者口碑与联系方式。',
            isPartOf: { '@type': 'WebSite', name: '蜜桃视频', url: 'https://www.mitaovideo.com' },
            about: { '@type': 'Organization', name: '蜜桃视频' },
          },
        ],
      };
      scriptEl = document.createElement('script');
      scriptEl.type = 'application/ld+json';
      scriptEl.setAttribute('data-schema', 'about-page');
      scriptEl.textContent = JSON.stringify(jsonLd);
      document.head.appendChild(scriptEl);
    }

    return () => {
      document.title = prevTitle;
      if (metaDescription) metaDescription.setAttribute('content', prevDesc);
      if (metaKeywords) metaKeywords.setAttribute('content', prevKeywords);
      if (canonical) canonical.setAttribute('href', prevHref);
      if (scriptEl && scriptEl.parentNode) {
        scriptEl.parentNode.removeChild(scriptEl);
      }
    };
  }, []);

  return null;
}